<template>
	<BaseCmsRotator
		:fetch="{code: 'homepage_rotator_v2', limit: 5, response_fields: ['id','title','code','template','link_target_blank','url_without_domain','image_upload_path','image_4_upload_path']}"
		@loadRotatorItems="loadRotatorItems"
		v-slot="{items}" thumb-preset="heroSlider">
		<div v-if="items?.length" class="hero">
			<BaseUiSwiper
				class="hero-slider"
				name="hero"
				:options="{
					slidesPerView: 1,
					effect: 'fade',
					pagination: {
						enabled: true	
					},
					autoplay: {
						delay: 5000,
						disableOnInteraction: true
					},
					loop: true,
				}"
				>
				<BaseUiSwiperSlide v-for="(item, index) in items" :key="item.id">
					<NuxtLink :target="item.link_target_blank == 1 ? '_blank' : null" :to="item.url_without_domain" class="hero-slide" @click="gtmTrack('select_promotion', {
						creative_name: item.title || '',
						creative_slot: item.template + (index + 1),
						promotion_id: item.id || '',
						promotion_name: item.title || '',
					})">
						<div class="hero-img">
							<BaseUiImage
								:data="item.image_upload_path_thumb"
								default="/images/no-image.jpg"
								:picture="[{maxWidth: '760px', src: item.image_4_upload_path_thumb_mobile?.thumb ? item.image_4_upload_path_thumb_mobile?.thumb : item.image_upload_path_thumb?.thumb, default: '/images/no-image-hero.jpg'}]"
							/>
						</div>
					</NuxtLink>
				</BaseUiSwiperSlide>
			</BaseUiSwiper>
		</div>
	</BaseCmsRotator>
</template>

<script setup>
	const {gtmTrack} = useGtmBB();
	function loadRotatorItems(value) {
		if (value?.items?.length) {
			value.items.forEach((item, index) => {
				let template = '';
				if(item.template) template = item.template;
				gtmTrack('view_promotion', {
					creative_name: item.title || '',
					creative_slot: value.creativeSlot + template + (index + 1),
					promotion_id: item.id || '',
					promotion_name: item.title || '',
				});
			});
		}
	}
</script>

<style scoped lang="less">
	.hero{
		width: auto; margin: 0 auto 24px; text-align: center; position: relative; background: #fff;

		@media (max-width: @m){margin-bottom: 12px;}
	}
	.hero-img{
		:deep(img){display: block; width: 100%; height: auto;}
	}
	.hero-slide{display: block; width: 100%;}
	:deep(.swiper-slide){
		background: #fff; height: 100%; display: none;
		&:nth-child(1){display: block;}
	}
	:deep(.swiper-initialized .swiper-slide){
		display: block;
		.hero-slide{width: 100%;}
	}
	:deep(.swiper-pagination){
		position: absolute; bottom: 15px; left: 0; right: 0; justify-content: center; z-index: 10; gap: 10px;
		&:not(.swiper-pagination-lock){display: flex;}
		.swiper-pagination-bullet{width: 8px; height: 8px; background: #D9D9D999; display: block; border-radius: 100px; .transition(width);}
		.swiper-pagination-bullet-active{width: 35px;}
	}
	:deep(.hero-swiper-dots){
		display: inline-flex; align-items: center; justify-content: center; position: absolute; bottom: 20px; left: 50%; transform: translateX(-50%); z-index: 111;

		@media (max-width: @m){bottom: 10px;}
	}
	:deep(.hero-swiper-dot){
		display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: 8px; height: 8px; margin: 0 6px; border-radius: 100%; background: rgba(217, 217, 217, 0.60); z-index: 1; transition: width 0.3s, border-radius 0.3s;
		&.is-active{width: 36px; border-radius: 6px;}

		@media (max-width: @m){
			width: 7px; height: 7px; margin: 0 5px;
			&.is-active{width: 29px; border-radius: 5px;}
		}
	}
</style>